/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Divider } from '@material-ui/core';
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import {
  Column,
  ContainerColumn,
  ContainerCount,
  ContainerImage,
  ContainerRow,
  Elevation,
  List,
  PDV,
  PlaceName,
  Small,
} from './styles';
import ManagerUser from '../../assets/usersManeger.png';
import DayRounded from '../daysRounded';
import IOSSwitch from '../IOsSwitch';

interface Props {
    name: string;
    photo: string;
    address: string;
    numberAddress: string
    contry: string;
    count: number;
    checked: boolean;
    onPress: Function;
    isPDV: boolean;
    navigation: Function;
}

const ItemPlaceGrid: React.FC<Props> = ({
  photo,
  name,
  address,
  numberAddress,
  contry,
  count,
  checked,
  onPress,
  isPDV,
  navigation,
}) => {
  const handleCount = () => {
    if (count >= 99) {
      return '99+';
    }
    return count;
  };

  return (
    <Elevation>
      <List
        onClick={() => navigation()}
        style={{ opacity: !checked ? 0.4 : undefined }}
      >
        <ContainerImage>
          <LazyLoadImage
            alt="Imagem não carregou"
            src={photo}
            loading="eager"
            style={{
              height: 180,
              width: '100%',
              borderTopLeftRadius: 30,
              borderTopRightRadius: 30,
              backgroundSize: 'cover',
            }}
          />
        </ContainerImage>
        <ContainerColumn>
          {isPDV ? <PDV>PDV</PDV> : null}
          <PlaceName style={{ marginTop: 5 }}>{name}</PlaceName>
          <Small>{`${address}, ${numberAddress}, ${contry}`}</Small>
        </ContainerColumn>
        <Column>
          <DayRounded />
        </Column>
        <Divider style={{ margin: 14 }} />
      </List>
      <ContainerRow>
        <ContainerCount>
          <LazyLoadImage
            alt="Imagem não carregou"
            src={ManagerUser}
            style={{ height: 16, width: 14, marginLeft: 20 }}
          />
          <Small style={{ marginLeft: 6, marginTop: 4 }}>{handleCount()}</Small>
        </ContainerCount>
        <IOSSwitch check={checked} onClick={() => onPress()} />
      </ContainerRow>
    </Elevation>
  );
};
export default ItemPlaceGrid;
